<mat-form-field class="form-field select grouped" subscriptSizing="dynamic">
	<mat-label>{{label}}</mat-label>
	<mat-select [formControl]="control">
		<ng-container *ngFor="let group of groupedOptions">
			<mat-optgroup class="grouped-label" [label]="group.label">
				<mat-option *ngFor="let o of group.options" [value]="o.value">{{o.displayName}}</mat-option>
			</mat-optgroup>
		</ng-container>
	</mat-select>
	<mat-hint *ngIf="hint">{{hint}}</mat-hint>
</mat-form-field>
